import { Getter } from 'vuex'
import { RootState, RootGetters } from '@/store/types'
import forOwn from '@/helpers/forOwn'
import { computeMatrixOrigin } from '@/helpers/computeMatrixOrigin'
import isEmpty from '@/helpers/isEmpty'
import { Platform } from '@/types/platform'

const getMatrixUrl: Getter<RootState, RootState> = (
  _state,
  getters: RootGetters
) => {
  const getter: RootGetters['getMatrixUrl'] = (payload) => {
    const platformOrigin =
      payload.platformOrigin ??
      (payload.name == 'article' || payload.name === 'draft-article'
        ? computeMatrixOrigin({
            platform: getters.getPlatform,
            sectionCode: payload.params.section,
          })
        : getters.getPlatformOrigin)

    const matrixUrl = new URL(platformOrigin)

    let path = ''

    switch (payload.name) {
      case 'topic':
      case 'article':
        path = `-${payload.params.id}`
        break

      case 'award':
        path = `awards/${payload.params.code}`
        break

      case 'draft-article':
        path = `draft/${payload.params.id}`
        break

      case 'podcast':
        path = `podcasts/${payload.params.code}`
        break

      case 'podcast-episode':
        path = `podcasts/${payload.params.section}/${payload.params.code}`
        break

      case 'expert':
        path = `experts/${payload.params.code}`
        break

      case 'recipe':
        path = `recipes/${payload.params.code}`
        break

      case 'recipe-ingredient':
        path = `recipes/ingredient/${payload.params.code}`
        break

      case 'recipe-category':
        path = `recipes/category/${payload.params.code}`
        break

      case 'biography':
        if (getters.getPlatform === Platform.vslova) {
          path = `persons/${payload.params.id}`
        } else {
          path = `${sectionBio(getters.getPlatform)}/biography/${
            payload.params.id
          }`
        }
        break

      case 'brands':
        path = `-${payload.params.id}`
        break

      case 'topicInterest':
        path = `topics/threads/${payload.params.code}`
        break

      case 'awards-story':
        path = `awards/story/${payload.params.id}`
        break

      default: {
        const code = payload.params.id ?? payload.params.code

        path = `${payload.name}/${code}`
        break
      }
    }

    if (payload.query) {
      forOwn(payload.query, (value, key) => {
        if (isEmpty(value)) {
          return
        }

        matrixUrl.searchParams.set(key, value)
      })
    }

    matrixUrl.pathname = matrixUrl.pathname + path.replace(/\/$/, '') + '/'
    return matrixUrl.toString()
  }

  return getter
}

const sectionBio = (platform: string) => {
  return ['cosmo', 'goodhouse'].includes(platform) ? 'stars' : 'persons'
}

export default getMatrixUrl
